import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTab1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22 4.25C22 3.83579 21.6642 3.5 21.25 3.5C20.8358 3.5 20.5 3.83579 20.5 4.25V19.25C20.5 19.6642 20.8358 20 21.25 20C21.6642 20 22 19.6642 22 19.25V4.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.2803 18.5303C11.9874 18.8232 11.5126 18.8232 11.2197 18.5303C10.9268 18.2374 10.9268 17.7626 11.2197 17.4697L16.1893 12.5H1.75C1.33579 12.5 1 12.1642 1 11.75C1 11.3358 1.33579 11 1.75 11H16.1893L11.2197 6.03033C10.9268 5.73744 10.9268 5.26256 11.2197 4.96967C11.5126 4.67678 11.9874 4.67678 12.2803 4.96967L18.5303 11.2197C18.8232 11.5126 18.8232 11.9874 18.5303 12.2803L12.2803 18.5303Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgTab1;
